// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"100\" height=\"100\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"100\" height=\"100\" fill=\"none\"/><circle cx=\"50\" cy=\"50\" r=\"1\" fill=\"rgba%28255,255,255,0.1%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== HOME PAGE ===== */
.home-page {
    width: 100%;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

/* Global background image (absolute) */
/* Global background is set inline in the React root to avoid webpack resolving public files in CSS. */

/* Hero Section */
.hero {
    position: relative;
    padding: 0;
    background: #000000;
    overflow: hidden;
    backface-visibility: hidden;
}

/* Split layout for content and Spline scene */
.hero-split-layout {
    position: relative;
    z-index: 2;
    display: flex;
    height: 100vh;
    width: 100%;
    transform: translate3d(0, 0, 0);
    contain: layout style;
}

/* Left side - Content */
.hero-content-wrapper {
    background-color: #000000;
    flex: 1 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0) 100%) right center/1px 100% no-repeat;
    position: relative;
    transform: translate3d(0, 0, 0);
}

/* Right side - Spline 3D */
.hero-spline-wrapper {
    flex: 1 1;
    position: relative;
    overflow: visible;
    z-index: 5;
    transform: translate3d(0, 0, 0);
    contain: layout style;
}

.hero-spline {
    width: 100%;
    overflow: visible;
    height: 100%;
}

/* Dark overlay for better contrast */
.hero::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.1) 100%);
    z-index: 1;
    pointer-events: none;
}


.hero::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    opacity: 0.3;
}

.hero-inner {
    position: relative;
    z-index: 1;
    display: flex;
    height: 100vh;
    width: 100%;
    justify-content: center;
    align-items: center;
}

.hero .reveal {
    font-size: 3rem;
    font-weight: 700;
    margin-bottom: 1rem;
    line-height: 1.2;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.hero-subtitle {
    font-size: 1.25rem;
    flex: 0 1 900px;
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    position: relative;
    z-index: 10;
    flex-wrap: wrap;
}

.btn {
    position: relative;
    overflow: hidden;
    padding: 10px 24px;
    z-index: 0;
    border-radius: 6px;
    transition: all 0.3s ease;
    display: inline-block;
    text-decoration: none;
}

.btn-primary {
    background: #ffffff;
    color: #1a5490;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-primary:hover {
    background: #f1f5f9;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.btn-secondary {
    background: transparent;
    color: #ffffff;
    border: 2px solid #ffffff;
}

.btn-secondary:hover {
    background: rgb(0, 0, 0);
    transform: translateY(-2px);
}

/* Ensure hero CTA buttons are visible above overlays */
.parallax-hero-cta .btn {
    position: relative;
    z-index: 30;
}


/* Mission Section */
.mission {
    background: #ffffff;
    overflow: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 0;
    min-height: 600px;
}

/* Keyframe Animations */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(40px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInLeft {
    from {
        opacity: 0;
        transform: translateX(-60px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes fadeInRight {
    from {
        opacity: 0;
        transform: translateX(60px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes scaleIn {
    from {
        opacity: 0;
        transform: scale(0.85);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes shimmer {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

@keyframes float {
    0%, 100% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(-10px);
    }
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

@keyframes glow {
    0%, 100% {
        box-shadow: 0 0 5px rgba(35, 31, 32, 0.1);
    }
    50% {
        box-shadow: 0 0 20px rgba(35, 31, 32, 0.2), 0 0 30px rgba(35, 31, 32, 0.1);
    }
}

/* Hide WebKit scrollbars for .mission and any scrollable children */
.mission::-webkit-scrollbar,
.mission *::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.mission .container {
    display: flex;
    height: 100%;
    padding: 0;
    max-width: 100%;
}

.mission-layout {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.mission-parallax {
    flex: 1 1;
    height: 100%;
    min-height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000000;
    padding: 4rem;
    animation: fadeInLeft 1s ease-out forwards;
}

.mission-logo {
    width: 90%;
    height: auto;
    max-width: 500px;
    object-fit: contain;
    object-position: center;
    display: block;
}




.mission-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 4rem 5rem;
    width: 100%;
    background: #ffffff;
    color: #000000;
    height: 100%;
    min-height: 600px;
    animation: fadeInRight 1s ease-out 0.2s backwards;
}

.mission h2 {
    font-size: 4rem;
    font-weight: 700;
    margin-bottom: 3rem;
    line-height: 1.1;
    letter-spacing: -0.03em;
    color: #000000;
    animation: slideDown 0.8s ease-out 0.4s backwards;
    position: relative;
}

.mission h2::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 80px;
    height: 4px;
    background: #000000;
    animation: fadeInUp 0.6s ease-out 0.8s backwards;
}

.mission p {
    font-size: clamp(0.96rem, 1.4vw, 1.05rem);
    line-height: 1.75;
    color: #333333;
    margin-bottom: 1.5rem;
    font-weight: 400;
    animation: fadeInUp 0.8s ease-out backwards;
}

.mission p:nth-of-type(1) {
    animation-delay: 0.6s;
}

.mission p:nth-of-type(2) {
    animation-delay: 0.8s;
}

.mission-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 3rem;
    margin-top: 4rem;
    padding-top: 3rem;
    border-top: 2px solid rgba(35, 31, 32, 0.1);
    width: 100%;
    animation: fadeInUp 0.8s ease-out 1s backwards;
}

.mission-stat {
    text-align: center;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
    position: relative;
    padding: 1.5rem;
    border-radius: 12px;
}

.mission-stat::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(35, 31, 32, 0.03), rgba(35, 31, 32, 0.01));
    opacity: 0;
    transition: opacity 0.3s ease;
}

.mission-stat:hover::before {
    opacity: 1;
}

.mission-stat:hover {
    transform: translateY(-8px) scale(1.05);
    box-shadow: 0 10px 30px rgba(35, 31, 32, 0.1);
}

.mission-stat:nth-child(1) {
    animation: scaleIn 0.6s ease-out 1.2s backwards;
}

.mission-stat:nth-child(2) {
    animation: scaleIn 0.6s ease-out 1.4s backwards;
}

.mission-stat:nth-child(3) {
    animation: scaleIn 0.6s ease-out 1.6s backwards;
}

.mission-stat-number {
    font-size: 3.5rem;
    font-weight: 800;
    margin-bottom: 0.75rem;
    line-height: 1;
    background: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-accent) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transition: all 0.3s ease;
}

.mission-stat:hover .mission-stat-number {
    transform: scale(1.1);
    filter: drop-shadow(0 0 8px rgba(35, 31, 32, 0.3));
}

.mission-stat-label {
    font-size: 0.875rem;
    color: rgba(35, 31, 32, 0.65);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    transition: all 0.3s ease;
}

.mission-stat:hover .mission-stat-label {
    color: rgba(35, 31, 32, 0.9);
    letter-spacing: 0.15em;
}


/* Edge Section */
.edge {
    width: fit-content;
    background: #000000;
    display: flex;
    align-items: center;
    padding: 30px;
    min-height: 100vh;
}

.edge-content {
    width: fit-content;
    min-height: 100vh;

}

.edge h2 {
    font-size: 2.25rem;
    color: #1a5490;
    margin-bottom: 3rem;
    text-align: center;
}

.edge-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    justify-content: center;
    align-items: center;
}


/* Categories Section */
.categories {
    min-height: 100vh;
    width: 100%;
    background: linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%);
    display: flex;
    align-items: center;
    padding: 120px 0 4rem 0;
}

.categories-content {
    width: 100%;
}

.categories h2 {
    font-size: 2.25rem;
    color: #1a5490;
    margin-bottom: 3rem;
    text-align: center;
}

.categories .grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
}

.cat-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 1.5rem;
    background: #ffffff;
    border: 2px solid #cbd5e1;
    border-radius: 12px;
    text-align: center;
    text-decoration: none;
    color: #1e293b;
    transition: all 0.3s ease;
    min-height: 150px;
}

.cat-card:hover {
    border-color: #ff6b35;
    background: linear-gradient(135deg, #fff5f2 0%, #ffffff 100%);
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(255, 107, 53, 0.2);
}

.cat-icon {
    font-size: 3rem;
    margin-bottom: 0.75rem;
}

.cat-card strong {
    font-size: 1.125rem;
    font-weight: 600;
    color: #1a5490;
}

/* Responsive */
@media (max-width: 1024px) {
    .hero {
        min-height: auto;
    }

    .hero-split-layout {
        flex-direction: column;
        height: auto;
        min-height: auto;
    }

    .hero-content-wrapper {
        flex: 1 1;
        min-height: 60vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .hero-spline-wrapper {
        flex: 1 1;
    }

    .hero::after {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.1) 100%);
    }

    .hero .reveal {
        font-size: 2rem;
    }

    .hero-subtitle {
        font-size: 1rem;
    }

    /* Tablet mission adjustments */
    .mission {
        min-height: auto;
    }

    .mission .container {
        height: auto;
    }

    .mission-layout {
        flex-direction: column;
        height: auto;
        
    }

    .mission-parallax {
        display: none;
        background-color: #000 !important;
    }

    .mission-logo {
        display: none;
    }

    .mission-content {
        flex: 1 1;
        min-height: auto;
        height: auto;
        padding: 3rem 2.5rem;
    }

    .mission h2 {
        font-size: 2.75rem;
    }

    .edge,
    .categories {
        min-height: auto;
        padding: 80px 0 3rem 0;
    }

    .edge h2,
    .categories h2 {
        font-size: 1.75rem;
    }

    .edge-grid {
        grid-template-columns: 1fr;
        justify-content: center;
    }

    .categories .grid {
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    }
}

/* Medium screens - better centering */
@media (min-width: 769px) and (max-width: 1024px) {
    .hero-content-wrapper {
        align-items: center;
        justify-content: center;
    }

    .parallax-hero-container {
        max-width: 100%;
        justify-content: center;
    }

    .parallax-hero-content {
        text-align: center;
        align-items: center;
    }

    .mission {
        min-height: auto;
    }

    .mission-layout {
        flex-direction: column;
    }

    .mission-parallax {
        display: none;
    }

    .mission-logo {
        display: none;
    }

    .mission-content {
        flex: 1 1;
        min-height: auto;
        height: auto;
        padding: 3rem 2rem;
    }

    .mission h2 {
        font-size: 2.5rem;
    }
}

/* Contact Section */
.contact-section {
    padding: 6rem 2rem;
    background: #000;
}

.contact-content {
    text-align: center;
    max-width: 1000px;
    margin: 0 auto;
}

.contact-content h2 {
    font-size: 3rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 1rem;
}

.contact-content>p {
    font-size: 1.25rem;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 3rem;
}

.contact-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-top: 3rem;
}

.contact-item {
    padding: 2rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 1rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.contact-item h3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: rgba(59, 130, 246, 0.9);
    margin-bottom: 0.5rem;
}

.contact-item p {
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
}

@media (max-width: 768px) {
    .contact-section {
        padding: 4rem 1rem;
    }

    .contact-content h2 {
        font-size: 2rem;
    }

    .contact-info {
        grid-template-columns: 1fr;
    }
}

/* Premium section framing to align with hero aesthetics */
.home-page {
    background:
        radial-gradient(circle at 20% 0%, rgba(255, 255, 255, 0.06), transparent 38%),
        radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.05), transparent 42%),
        #000;
}

.premium-block {
    width: 100%;
    box-sizing: border-box;
}

.premium-panel {
    position: relative;
    overflow: hidden;
}

.premium-panel::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 28px;
    opacity: 0.75;
}

.premium-panel::after {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), transparent 45%);
    border-radius: 28px;
}

#mission.premium-panel,
#capabilities.premium-panel,
#products.premium-panel,
#why-choose-us.premium-panel,
.premium-clients {
    border-radius: 0;
    backdrop-filter: none;
    background: transparent;
    box-shadow: none;
    margin: 0;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
}

#mission.premium-panel .mission-content {
    background: rgba(255, 255, 255, 0.92);
}


@media (max-width: 768px) {
    .mission {
        min-height: auto;
        padding: 0;
    }

    .mission .container {
        flex-direction: column;
        height: auto;
    }

    .mission-layout {
        flex-direction: column;
        height: auto;
    }

    .mission-parallax {
        display: none;
    }

    .mission-logo {
        display: none;
    }

    .mission-content {
        flex: 1 1;
        min-height: auto;
        height: auto;
        padding: 3rem 1.5rem;
    }

    .mission h2 {
        font-size: 2rem;
        margin-bottom: 1.5rem;
    }

    .mission p {
        font-size: 0.95rem;
    }

    .premium-block {
        padding: 0.7rem;
    }

    #mission.premium-panel,
    #capabilities.premium-panel,
    #products.premium-panel,
    #why-choose-us.premium-panel,
    .premium-clients {
        border-radius: 0;
        margin-bottom: 0;
    }

    .premium-panel::before,
    .premium-panel::after {
        border-radius: 18px;
    }
}

/* Strict monochrome immersive override */
.home-page,
.home-page * {
    color: #fff;
}

.home-page {
    background: #000 !important;
}

.premium-panel,
.premium-block,
#mission.premium-panel,
#capabilities.premium-panel,
#products.premium-panel,
#why-choose-us.premium-panel,
.premium-clients {
    background: #000 !important;
    border: 0 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    margin: 0 !important;
}

.premium-panel::before,
.premium-panel::after {
    display: none !important;
}

.mission,
.mission > .container,
.mission .container {
    background: #ffffff !important;
}

.mission-layout {
    max-width: 100%;
    margin: 0;
}

.mission-parallax {
    min-height: auto;
    border-right: none !important;
}

.mission-parallax::before {
    display: none;
}

@media (max-width: 1024px) {
    .mission-layout {
        border: 0;
    }
}

@media (max-width: 480px) {
    .mission {
        min-height: auto;
        padding: 0;
    }

    .mission .container {
        flex-direction: column;
        height: auto;
    }

    .mission-layout {
        flex-direction: column;
        height: auto;
    }

    .mission-parallax {
        display: none;
    }

    .mission-logo {
        display: none;
    }

    .mission-content {
        flex: 1 1;
        min-height: auto;
        height: auto;
        padding: 4rem 2rem;
    }

    .mission h2 {
        font-size: 1.5rem;
        margin-bottom: 1.25rem;
    }

    .mission h2::after {
        width: 50px;
        height: 3px;
    }

    .mission p {
        font-size: 0.9rem;
        margin-bottom: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,uCAAuC;AACvC,sGAAsG;;AAEtG,iBAAiB;AACjB;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA,8CAA8C;AAC9C;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,aAAa;IACb,WAAW;IACX,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,yBAAyB;IACzB,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yJAAyJ;IACzJ,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA,2BAA2B;AAC3B;IACI,SAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,0GAA0G;IAC1G,UAAU;IACV,oBAAoB;AACxB;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mDAAqN;IACrN,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA,uDAAuD;AACvD;IACI,kBAAkB;IAClB,WAAW;AACf;;;AAGA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,UAAU;IACV,iBAAiB;AACrB;;AAEA,wBAAwB;AACxB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;IACA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,yCAAyC;IAC7C;IACA;QACI,0EAA0E;IAC9E;AACJ;;AAEA,oEAAoE;AACpE;;IAEI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;;;;AAKA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;IAC3C,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,sDAAsD;IACtD,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,mFAAmF;IACnF,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uCAAuC;IACvC,6CAA6C;AACjD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,wFAAwF;IACxF,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;;;AAGA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA,uBAAuB;AACvB;IACI,iBAAiB;IACjB,WAAW;IACX,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,6DAA6D;IAC7D,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,SAAO;QACP,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,2GAA2G;IAC/G;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,+BAA+B;IAC/B;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,YAAY;;IAEhB;;IAEA;QACI,aAAa;QACb,iCAAiC;IACrC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAO;QACP,gBAAgB;QAChB,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,2DAA2D;IAC/D;AACJ;;AAEA,sCAAsC;AACtC;IACI;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAO;QACP,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,0DAA0D;AAC1D;IACI;;;YAGQ;AACZ;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,+EAA+E;IAC/E,mBAAmB;AACvB;;AAEA;;;;;IAKI,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;;AAGA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAO;QACP,gBAAgB;QAChB,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;;;;;QAKI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;;QAEI,mBAAmB;IACvB;AACJ;;AAEA,yCAAyC;AACzC;;IAEI,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;;;;;IAOI,2BAA2B;IAC3B,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;;IAGI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAO;QACP,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;AACJ","sourcesContent":["/* ===== HOME PAGE ===== */\n.home-page {\n    width: 100%;\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n}\n\n/* Global background image (absolute) */\n/* Global background is set inline in the React root to avoid webpack resolving public files in CSS. */\n\n/* Hero Section */\n.hero {\n    position: relative;\n    padding: 0;\n    background: #000000;\n    overflow: hidden;\n    backface-visibility: hidden;\n}\n\n/* Split layout for content and Spline scene */\n.hero-split-layout {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    transform: translate3d(0, 0, 0);\n    contain: layout style;\n}\n\n/* Left side - Content */\n.hero-content-wrapper {\n    background-color: #000000;\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0) 100%) right center/1px 100% no-repeat;\n    position: relative;\n    transform: translate3d(0, 0, 0);\n}\n\n/* Right side - Spline 3D */\n.hero-spline-wrapper {\n    flex: 1;\n    position: relative;\n    overflow: visible;\n    z-index: 5;\n    transform: translate3d(0, 0, 0);\n    contain: layout style;\n}\n\n.hero-spline {\n    width: 100%;\n    overflow: visible;\n    height: 100%;\n}\n\n/* Dark overlay for better contrast */\n.hero::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.1) 100%);\n    z-index: 1;\n    pointer-events: none;\n}\n\n\n.hero::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: url('data:image/svg+xml,<svg width=\"100\" height=\"100\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"100\" height=\"100\" fill=\"none\"/><circle cx=\"50\" cy=\"50\" r=\"1\" fill=\"rgba(255,255,255,0.1)\"/></svg>');\n    opacity: 0.3;\n}\n\n.hero-inner {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n}\n\n.hero .reveal {\n    font-size: 3rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n    line-height: 1.2;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.hero-subtitle {\n    font-size: 1.25rem;\n    flex: 0 1 900px;\n    width: 100%;\n    max-width: 900px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem;\n    position: relative;\n    z-index: 10;\n    flex-wrap: wrap;\n}\n\n.btn {\n    position: relative;\n    overflow: hidden;\n    padding: 10px 24px;\n    z-index: 0;\n    border-radius: 6px;\n    transition: all 0.3s ease;\n    display: inline-block;\n    text-decoration: none;\n}\n\n.btn-primary {\n    background: #ffffff;\n    color: #1a5490;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.btn-primary:hover {\n    background: #f1f5f9;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.btn-secondary {\n    background: transparent;\n    color: #ffffff;\n    border: 2px solid #ffffff;\n}\n\n.btn-secondary:hover {\n    background: rgb(0, 0, 0);\n    transform: translateY(-2px);\n}\n\n/* Ensure hero CTA buttons are visible above overlays */\n.parallax-hero-cta .btn {\n    position: relative;\n    z-index: 30;\n}\n\n\n/* Mission Section */\n.mission {\n    background: #ffffff;\n    overflow: hidden;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    padding: 0;\n    min-height: 600px;\n}\n\n/* Keyframe Animations */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(40px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes fadeInLeft {\n    from {\n        opacity: 0;\n        transform: translateX(-60px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes fadeInRight {\n    from {\n        opacity: 0;\n        transform: translateX(60px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes scaleIn {\n    from {\n        opacity: 0;\n        transform: scale(0.85);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes shimmer {\n    0% {\n        background-position: -1000px 0;\n    }\n    100% {\n        background-position: 1000px 0;\n    }\n}\n\n@keyframes float {\n    0%, 100% {\n        transform: translateY(0px);\n    }\n    50% {\n        transform: translateY(-10px);\n    }\n}\n\n@keyframes pulse {\n    0%, 100% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.05);\n    }\n}\n\n@keyframes glow {\n    0%, 100% {\n        box-shadow: 0 0 5px rgba(35, 31, 32, 0.1);\n    }\n    50% {\n        box-shadow: 0 0 20px rgba(35, 31, 32, 0.2), 0 0 30px rgba(35, 31, 32, 0.1);\n    }\n}\n\n/* Hide WebKit scrollbars for .mission and any scrollable children */\n.mission::-webkit-scrollbar,\n.mission *::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n}\n\n.mission .container {\n    display: flex;\n    height: 100%;\n    padding: 0;\n    max-width: 100%;\n}\n\n.mission-layout {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.mission-parallax {\n    flex: 1;\n    height: 100%;\n    min-height: 600px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #000000;\n    padding: 4rem;\n    animation: fadeInLeft 1s ease-out forwards;\n}\n\n.mission-logo {\n    width: 90%;\n    height: auto;\n    max-width: 500px;\n    object-fit: contain;\n    object-position: center;\n    display: block;\n}\n\n\n\n\n.mission-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 4rem 5rem;\n    width: 100%;\n    background: #ffffff;\n    color: #000000;\n    height: 100%;\n    min-height: 600px;\n    animation: fadeInRight 1s ease-out 0.2s backwards;\n}\n\n.mission h2 {\n    font-size: 4rem;\n    font-weight: 700;\n    margin-bottom: 3rem;\n    line-height: 1.1;\n    letter-spacing: -0.03em;\n    color: #000000;\n    animation: slideDown 0.8s ease-out 0.4s backwards;\n    position: relative;\n}\n\n.mission h2::after {\n    content: '';\n    position: absolute;\n    bottom: -10px;\n    left: 0;\n    width: 80px;\n    height: 4px;\n    background: #000000;\n    animation: fadeInUp 0.6s ease-out 0.8s backwards;\n}\n\n.mission p {\n    font-size: clamp(0.96rem, 1.4vw, 1.05rem);\n    line-height: 1.75;\n    color: #333333;\n    margin-bottom: 1.5rem;\n    font-weight: 400;\n    animation: fadeInUp 0.8s ease-out backwards;\n}\n\n.mission p:nth-of-type(1) {\n    animation-delay: 0.6s;\n}\n\n.mission p:nth-of-type(2) {\n    animation-delay: 0.8s;\n}\n\n.mission-stats {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 3rem;\n    margin-top: 4rem;\n    padding-top: 3rem;\n    border-top: 2px solid rgba(35, 31, 32, 0.1);\n    width: 100%;\n    animation: fadeInUp 0.8s ease-out 1s backwards;\n}\n\n.mission-stat {\n    text-align: center;\n    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n    cursor: pointer;\n    position: relative;\n    padding: 1.5rem;\n    border-radius: 12px;\n}\n\n.mission-stat::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: 12px;\n    background: linear-gradient(135deg, rgba(35, 31, 32, 0.03), rgba(35, 31, 32, 0.01));\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.mission-stat:hover::before {\n    opacity: 1;\n}\n\n.mission-stat:hover {\n    transform: translateY(-8px) scale(1.05);\n    box-shadow: 0 10px 30px rgba(35, 31, 32, 0.1);\n}\n\n.mission-stat:nth-child(1) {\n    animation: scaleIn 0.6s ease-out 1.2s backwards;\n}\n\n.mission-stat:nth-child(2) {\n    animation: scaleIn 0.6s ease-out 1.4s backwards;\n}\n\n.mission-stat:nth-child(3) {\n    animation: scaleIn 0.6s ease-out 1.6s backwards;\n}\n\n.mission-stat-number {\n    font-size: 3.5rem;\n    font-weight: 800;\n    margin-bottom: 0.75rem;\n    line-height: 1;\n    background: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-accent) 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    transition: all 0.3s ease;\n}\n\n.mission-stat:hover .mission-stat-number {\n    transform: scale(1.1);\n    filter: drop-shadow(0 0 8px rgba(35, 31, 32, 0.3));\n}\n\n.mission-stat-label {\n    font-size: 0.875rem;\n    color: rgba(35, 31, 32, 0.65);\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    transition: all 0.3s ease;\n}\n\n.mission-stat:hover .mission-stat-label {\n    color: rgba(35, 31, 32, 0.9);\n    letter-spacing: 0.15em;\n}\n\n\n/* Edge Section */\n.edge {\n    width: fit-content;\n    background: #000000;\n    display: flex;\n    align-items: center;\n    padding: 30px;\n    min-height: 100vh;\n}\n\n.edge-content {\n    width: fit-content;\n    min-height: 100vh;\n\n}\n\n.edge h2 {\n    font-size: 2.25rem;\n    color: #1a5490;\n    margin-bottom: 3rem;\n    text-align: center;\n}\n\n.edge-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    justify-content: center;\n    align-items: center;\n}\n\n\n/* Categories Section */\n.categories {\n    min-height: 100vh;\n    width: 100%;\n    background: linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%);\n    display: flex;\n    align-items: center;\n    padding: 120px 0 4rem 0;\n}\n\n.categories-content {\n    width: 100%;\n}\n\n.categories h2 {\n    font-size: 2.25rem;\n    color: #1a5490;\n    margin-bottom: 3rem;\n    text-align: center;\n}\n\n.categories .grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1.5rem;\n}\n\n.cat-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem 1.5rem;\n    background: #ffffff;\n    border: 2px solid #cbd5e1;\n    border-radius: 12px;\n    text-align: center;\n    text-decoration: none;\n    color: #1e293b;\n    transition: all 0.3s ease;\n    min-height: 150px;\n}\n\n.cat-card:hover {\n    border-color: #ff6b35;\n    background: linear-gradient(135deg, #fff5f2 0%, #ffffff 100%);\n    transform: translateY(-5px);\n    box-shadow: 0 8px 20px rgba(255, 107, 53, 0.2);\n}\n\n.cat-icon {\n    font-size: 3rem;\n    margin-bottom: 0.75rem;\n}\n\n.cat-card strong {\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: #1a5490;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n    .hero {\n        min-height: auto;\n    }\n\n    .hero-split-layout {\n        flex-direction: column;\n        height: auto;\n        min-height: auto;\n    }\n\n    .hero-content-wrapper {\n        flex: 1;\n        min-height: 60vh;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .hero-spline-wrapper {\n        flex: 1;\n    }\n\n    .hero::after {\n        background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.1) 100%);\n    }\n\n    .hero .reveal {\n        font-size: 2rem;\n    }\n\n    .hero-subtitle {\n        font-size: 1rem;\n    }\n\n    /* Tablet mission adjustments */\n    .mission {\n        min-height: auto;\n    }\n\n    .mission .container {\n        height: auto;\n    }\n\n    .mission-layout {\n        flex-direction: column;\n        height: auto;\n        \n    }\n\n    .mission-parallax {\n        display: none;\n        background-color: #000 !important;\n    }\n\n    .mission-logo {\n        display: none;\n    }\n\n    .mission-content {\n        flex: 1;\n        min-height: auto;\n        height: auto;\n        padding: 3rem 2.5rem;\n    }\n\n    .mission h2 {\n        font-size: 2.75rem;\n    }\n\n    .edge,\n    .categories {\n        min-height: auto;\n        padding: 80px 0 3rem 0;\n    }\n\n    .edge h2,\n    .categories h2 {\n        font-size: 1.75rem;\n    }\n\n    .edge-grid {\n        grid-template-columns: 1fr;\n        justify-content: center;\n    }\n\n    .categories .grid {\n        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    }\n}\n\n/* Medium screens - better centering */\n@media (min-width: 769px) and (max-width: 1024px) {\n    .hero-content-wrapper {\n        align-items: center;\n        justify-content: center;\n    }\n\n    .parallax-hero-container {\n        max-width: 100%;\n        justify-content: center;\n    }\n\n    .parallax-hero-content {\n        text-align: center;\n        align-items: center;\n    }\n\n    .mission {\n        min-height: auto;\n    }\n\n    .mission-layout {\n        flex-direction: column;\n    }\n\n    .mission-parallax {\n        display: none;\n    }\n\n    .mission-logo {\n        display: none;\n    }\n\n    .mission-content {\n        flex: 1;\n        min-height: auto;\n        height: auto;\n        padding: 3rem 2rem;\n    }\n\n    .mission h2 {\n        font-size: 2.5rem;\n    }\n}\n\n/* Contact Section */\n.contact-section {\n    padding: 6rem 2rem;\n    background: #000;\n}\n\n.contact-content {\n    text-align: center;\n    max-width: 1000px;\n    margin: 0 auto;\n}\n\n.contact-content h2 {\n    font-size: 3rem;\n    font-weight: 700;\n    color: #fff;\n    margin-bottom: 1rem;\n}\n\n.contact-content>p {\n    font-size: 1.25rem;\n    color: rgba(255, 255, 255, 0.7);\n    margin-bottom: 3rem;\n}\n\n.contact-info {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 2rem;\n    margin-top: 3rem;\n}\n\n.contact-item {\n    padding: 2rem;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 1rem;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.contact-item h3 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: rgba(59, 130, 246, 0.9);\n    margin-bottom: 0.5rem;\n}\n\n.contact-item p {\n    color: rgba(255, 255, 255, 0.8);\n    line-height: 1.6;\n}\n\n@media (max-width: 768px) {\n    .contact-section {\n        padding: 4rem 1rem;\n    }\n\n    .contact-content h2 {\n        font-size: 2rem;\n    }\n\n    .contact-info {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Premium section framing to align with hero aesthetics */\n.home-page {\n    background:\n        radial-gradient(circle at 20% 0%, rgba(255, 255, 255, 0.06), transparent 38%),\n        radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.05), transparent 42%),\n        #000;\n}\n\n.premium-block {\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.premium-panel {\n    position: relative;\n    overflow: hidden;\n}\n\n.premium-panel::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 28px;\n    opacity: 0.75;\n}\n\n.premium-panel::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), transparent 45%);\n    border-radius: 28px;\n}\n\n#mission.premium-panel,\n#capabilities.premium-panel,\n#products.premium-panel,\n#why-choose-us.premium-panel,\n.premium-clients {\n    border-radius: 0;\n    backdrop-filter: none;\n    background: transparent;\n    box-shadow: none;\n    margin: 0;\n    width: 100vw;\n    margin-left: calc(-50vw + 50%);\n}\n\n#mission.premium-panel .mission-content {\n    background: rgba(255, 255, 255, 0.92);\n}\n\n\n@media (max-width: 768px) {\n    .mission {\n        min-height: auto;\n        padding: 0;\n    }\n\n    .mission .container {\n        flex-direction: column;\n        height: auto;\n    }\n\n    .mission-layout {\n        flex-direction: column;\n        height: auto;\n    }\n\n    .mission-parallax {\n        display: none;\n    }\n\n    .mission-logo {\n        display: none;\n    }\n\n    .mission-content {\n        flex: 1;\n        min-height: auto;\n        height: auto;\n        padding: 3rem 1.5rem;\n    }\n\n    .mission h2 {\n        font-size: 2rem;\n        margin-bottom: 1.5rem;\n    }\n\n    .mission p {\n        font-size: 0.95rem;\n    }\n\n    .premium-block {\n        padding: 0.7rem;\n    }\n\n    #mission.premium-panel,\n    #capabilities.premium-panel,\n    #products.premium-panel,\n    #why-choose-us.premium-panel,\n    .premium-clients {\n        border-radius: 0;\n        margin-bottom: 0;\n    }\n\n    .premium-panel::before,\n    .premium-panel::after {\n        border-radius: 18px;\n    }\n}\n\n/* Strict monochrome immersive override */\n.home-page,\n.home-page * {\n    color: #fff;\n}\n\n.home-page {\n    background: #000 !important;\n}\n\n.premium-panel,\n.premium-block,\n#mission.premium-panel,\n#capabilities.premium-panel,\n#products.premium-panel,\n#why-choose-us.premium-panel,\n.premium-clients {\n    background: #000 !important;\n    border: 0 !important;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n    margin: 0 !important;\n}\n\n.premium-panel::before,\n.premium-panel::after {\n    display: none !important;\n}\n\n.mission,\n.mission > .container,\n.mission .container {\n    background: #ffffff !important;\n}\n\n.mission-layout {\n    max-width: 100%;\n    margin: 0;\n}\n\n.mission-parallax {\n    min-height: auto;\n    border-right: none !important;\n}\n\n.mission-parallax::before {\n    display: none;\n}\n\n@media (max-width: 1024px) {\n    .mission-layout {\n        border: 0;\n    }\n}\n\n@media (max-width: 480px) {\n    .mission {\n        min-height: auto;\n        padding: 0;\n    }\n\n    .mission .container {\n        flex-direction: column;\n        height: auto;\n    }\n\n    .mission-layout {\n        flex-direction: column;\n        height: auto;\n    }\n\n    .mission-parallax {\n        display: none;\n    }\n\n    .mission-logo {\n        display: none;\n    }\n\n    .mission-content {\n        flex: 1;\n        min-height: auto;\n        height: auto;\n        padding: 4rem 2rem;\n    }\n\n    .mission h2 {\n        font-size: 1.5rem;\n        margin-bottom: 1.25rem;\n    }\n\n    .mission h2::after {\n        width: 50px;\n        height: 3px;\n    }\n\n    .mission p {\n        font-size: 0.9rem;\n        margin-bottom: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
